import * as types from "@/vuex/types"

//API
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { savedChannel } from '@/lib/types'
import { paginationParams, deviceParams } from '@/api/params'
import { stat } from "fs";

const state = {
  default: {
    life: []
  }
}

const getters = {
  default: state => state.default
}

const actions = {
  async addRemoveSaved ({ commit, rootGetters }, payload ) {
    const category = savedChannel[payload.category]

    let data = {
      'channel_id': payload.item.id,
      'channel_type': category
    };

    const addOrRemove = await api.patch(apiV2.savedDetail(rootGetters.defaultSaved), data, { needToken: true })

    const params = {
      status: addOrRemove,
      data: data,
      category: payload.category
    }

    if (addOrRemove.status === 200) {
      if (state.default[payload.category].includes(data.channel_id)) {
        commit(types.REMOVE_SAVED, params)

        const msg = {
          title: 'Removed from saved',
          text: payload.item.location_name + ' has been removed from saved folder',
          type: 'primary'
        }
        return { response: addOrRemove, msg: msg }
      } else {
        commit(types.ADD_SAVED, params)

        const msg = {
          title: 'Added to saved',
          text: payload.item.location_name + ' has been added to saved folder',
          type: 'success'
        }

        return { response: addOrRemove, msg: msg }
      }
    } else {
      const msg = {
        title: 'Error',
        text: 'sorry something went wrong!',
        type: 'danger'
      }

      return { response: addOrRemove, msg: msg }
    }

  },
  async loadSaved ({commit}, payload ) {
    const allSaved = await api.get(apiV2.saved, { needToken: true });

    const defaultSaved = allSaved.data.filter(function (item) {
      return item.is_default == true
    });

    const defaultId = defaultSaved.pop().id

    const defaultItem = await api.get(apiV2.savedDetail(defaultId), { needToken: true })

    commit(types.ALL_SAVED, defaultItem)
    commit(types.DEFAULT_SAVED, defaultId)
  }
}

const mutations = {
  [types.REMOVE_SAVED] (state, response) {
    const { data, status, category } = response

    const index = state.default[category].map(x => {
      return x
    }).indexOf(data.channel_id)

    state.default[category].splice(index, 1)
  },

  [types.ADD_SAVED] (state, response) {
    const { data, status, category } = response

    state.default[category].push(data.channel_id)
  },

  [types.ALL_SAVED] (state, response) {
    const { data } = response
    Object.keys(data.lists).forEach(element => {
      data.lists[element] = data.lists[element].map(el => el.id)
    });
    state.default = data.lists
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}